import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	salaryComponents: null,
	error: "",
	loading: false,
};

// ADD_salaryComponent
export const addSalaryComponents = createAsyncThunk(
	"settings/addSalaryComponents",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `setting-salary/`,
				data: {
					...values,
				},
			});
			toast.success("Salary Component Added Successfully");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Salary Component try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_salaryComponent
export const deleteSalaryComponents = createAsyncThunk(
	"settings/deleteSalaryComponents",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `setting-salary/${id}`,
				data: {
					status: false,
				},
			});

			toast.success("Salary Component Deleted");
			return resp.data.id;
		} catch (error) {
			toast.error("Error in deleting salary component try again");
			console.log(error.message);
		}
	}
);

// salaryComponent_DETAILS
export const loadSingelSalaryComponents = createAsyncThunk(
	"settings/loadSingelSalaryComponents",
	async (id) => {
		try {
			const data = await axios.get(`setting-salary/${id}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// salaryComponentS
export const loadAllSalaryComponents = createAsyncThunk(
	"settings/loadAllSalaryComponents",
	async () => {
		try {
			const { data } = await axios.get(`setting-salary/?status=true`);
			console.log("salary component SLICE", data);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// export const loadAllSalaryComponentsByEmployee = createAsyncThunk(
// 	"salaryComponent/loadAllSalaryComponents",
// 	async () => {
// 		try {
// 			const { data } = await axios.get(`salaryComponent/employee`);
// 			return data;
// 		} catch (error) {
// 			console.log(error.message);
// 		}
// 	}
// );

// UPDATE_salaryComponent

export const updateSalaryComponents = createAsyncThunk(
	"settings/updateSalaryComponents",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `setting-salary/${id}`,
				data: {
					...values,
				},
			});
			toast.success("SalaryComponent Updated");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating salary component try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const salaryComponentsSlice = createSlice({
	name: "salaryComponents",
	initialState,
	reducers: {
		clearSalaryComponents: (state) => {
			state.salaryComponents = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for loadAllSalaryComponents ======

		builder.addCase(loadAllSalaryComponents.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadAllSalaryComponents.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(loadAllSalaryComponents.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 1) ====== builders for loadAllSalaryComponentsByEmployee ======

		// builder.addCase(loadAllSalaryComponentsByEmployee.pending, (state) => {
		// 	state.loading = true;
		// });

		// builder.addCase(loadAllSalaryComponentsByEmployee.fulfilled, (state, action) => {
		// 	state.loading = false;
		// 	state.employee = action.payload;
		// });

		// builder.addCase(loadAllSalaryComponentsByEmployee.rejected, (state, action) => {
		// 	state.loading = false;
		// 	state.error = action.payload.message;
		// });

		// 2) ====== builders for addSalaryComponents ======

		builder.addCase(addSalaryComponents.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addSalaryComponents.fulfilled, (state, action) => {
			state.loading = false;

			if (!Array.isArray(state.list)) {
				state.list = [];
			}
			const list = [...state.list];
			list.push(action.payload);
			state.list = list;
		});

		builder.addCase(addSalaryComponents.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for loadSingelSalaryComponents ======

		builder.addCase(loadSingelSalaryComponents.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(loadSingelSalaryComponents.fulfilled, (state, action) => {
			state.loading = false;
			state.salaryComponents = action.payload.data;
		});

		builder.addCase(loadSingelSalaryComponents.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 3) ====== builders for updateSalaryComponents ======

		builder.addCase(updateSalaryComponents.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateSalaryComponents.fulfilled, (state, action) => {
			state.loading = false;
			const list = [...state.list];
			const index = list.findIndex(
				(salaryComponent) => salaryComponent.id === parseInt(action.payload.data.id)
			);
			list[index] = action.payload.data;
			state.list = list;
		});

		builder.addCase(updateSalaryComponents.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteSalaryComponents ======

		builder.addCase(deleteSalaryComponents.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteSalaryComponents.fulfilled, (state, action) => {
			state.loading = false;
			const filterSalaryComponent = state.list.filter(
				(salaryComponent) => salaryComponent.id !== parseInt(action.payload) && salaryComponent
			);
			state.list = filterSalaryComponent;
		});

		builder.addCase(deleteSalaryComponents.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default salaryComponentsSlice.reducer;
export const { clearSalaryComponents } = salaryComponentsSlice.actions;
